<template><section><div class="card" style="margin:0;width:300px;text-align:left">
  <div class="van-doc-intro">
    <img class="van-doc-intro__logo" style="width: 120px; height: 120px;" src="https://img.yzcdn.cn/vant/logo.png">
  </div>
</div>
<h4>Vant 企业端常用组件</h4>
<h5>card组件</h5>
<pre v-pre><code v-pre class="language-&lt;template&gt;">      &lt;div class='main'&gt;
      &lt;div class='cardDiv'&gt;
        &lt;el-scrollbar style=&quot;height:100%&quot;&gt;
        &lt;van-sticky&gt;
          &lt;van-card title=&quot;订单详情页&quot;&gt;
            &lt;div slot=&quot;title&quot;&gt;
                &lt;div&gt;
                  &lt;div class='new_order_title'&gt;
                    &lt;div class='new_order_orderno'&gt;&lt;span&gt;订单编号：&lt;/span&gt;&lt;span&gt;BB06836365953495&lt;/span&gt;&lt;div class='new_order_status'&gt;
                      &lt;van-tag plain type=&quot;danger&quot; style=&quot;margin-right: 5px;&quot;&gt;
                        异常订单
                      &lt;/van-tag&gt;
                    &lt;/div&gt;
                    &lt;/div&gt;
                  &lt;/div&gt;
                  &lt;div class='new_order_error'&gt;
                      &lt;span&gt;异常原因: &lt;/span&gt;&lt;span&gt;201-云端识别失败&lt;/span&gt;
                  &lt;/div&gt;
                  &lt;div class='new_order_mername'&gt;&lt;span&gt;会员昵称: &lt;/span&gt;&lt;span&gt;苏晓燕&lt;/span&gt;&lt;/div&gt;
                  &lt;div class='new_order_container'&gt;&lt;span&gt;联系方式: &lt;/span&gt;&lt;span&gt;15801030115&lt;/span&gt;&lt;/div&gt;
                  &lt;div class='new_order_creatime'&gt;
                      &lt;span&gt;下单日期：&lt;/span&gt;&lt;span&gt;2019-05-01  12:12:12&lt;/span&gt;
                  &lt;/div&gt;
                  &lt;div class='clear'&gt;&lt;/div&gt;
                &lt;/div&gt;
            &lt;/div&gt;
          &lt;/van-card&gt;
        &lt;/van-sticky&gt;
      &lt;van-collapse v-model=&quot;activeNames&quot;&gt;
        &lt;van-collapse-item name=&quot;1&quot;&gt;
          &lt;div slot=&quot;title&quot;&gt;订单明细&lt;span class=&quot;detitle&quot;&gt;共4件商品合计:&lt;/span&gt;&lt;span class='price'&gt;￥139&lt;/span&gt;&lt;/div&gt;
           &lt;van-card :thumb=&quot;imageURL&quot;&gt;
        &lt;div slot=&quot;title&quot;&gt;
            &lt;div&gt;
              &lt;div class='new_detail_goods'&gt;&lt;span&gt;商品：&lt;/span&gt;&lt;span&gt;百事可乐&lt;/span&gt;&lt;/div&gt;
                &lt;ul class=&quot;goodInfo&quot;&gt;
                  &lt;li&gt;&lt;span&gt;价格：&lt;/span&gt;&lt;span&gt;￥20.0&lt;/span&gt;&lt;/li&gt;
                  &lt;li&gt;&lt;span&gt;数量：&lt;/span&gt;&lt;span&gt;10件&lt;/span&gt;&lt;/li&gt;
                  &lt;li&gt;&lt;span&gt;原价：&lt;/span&gt;&lt;span&gt;￥20.0&lt;/span&gt;&lt;/li&gt;
                &lt;/ul&gt;
            &lt;/div&gt;
        &lt;/div&gt;
      &lt;/van-card&gt;
       &lt;van-card :thumb=&quot;imageURL&quot;&gt;
        &lt;div slot=&quot;title&quot;&gt;
            &lt;div&gt;
              &lt;div class='new_detail_goods'&gt;&lt;span&gt;商品：&lt;/span&gt;&lt;span&gt;百事可乐&lt;/span&gt;&lt;/div&gt;
                &lt;ul class=&quot;goodInfo&quot;&gt;
                  &lt;li&gt;&lt;span&gt;价格：&lt;/span&gt;&lt;span&gt;￥20.0&lt;/span&gt;&lt;/li&gt;
                  &lt;li&gt;&lt;span&gt;数量：&lt;/span&gt;&lt;span&gt;10件&lt;/span&gt;&lt;/li&gt;
                  &lt;li&gt;&lt;span&gt;原价：&lt;/span&gt;&lt;span&gt;￥20.0&lt;/span&gt;&lt;/li&gt;
                &lt;/ul&gt;
            &lt;/div&gt;
        &lt;/div&gt;
      &lt;/van-card&gt;
        &lt;/van-collapse-item&gt;
        &lt;van-collapse-item title=&quot;支付信息&quot; name=&quot;2&quot; icon=&quot;shop-o&quot;&gt;
           &lt;van-card&gt;
              &lt;div slot=&quot;title&quot;&gt;
                  &lt;div&gt;
                    &lt;div class='new_order_title'&gt;
                      &lt;div class='new_pay_price'&gt;&lt;span&gt;退款金额：&lt;/span&gt;&lt;span&gt;￥10.00&lt;/span&gt;&lt;div class='new_order_status'&gt;
                      &lt;/div&gt;
                      &lt;/div&gt;
                    &lt;/div&gt;
                    &lt;div class='new_order_mername'&gt;&lt;span&gt;退款单号: &lt;/span&gt;&lt;span&gt;cs00987934567&lt;/span&gt;&lt;/div&gt;
                    &lt;div class='new_order_container'&gt;&lt;span&gt;第三方退款单号: &lt;/span&gt;&lt;span&gt;ab999023904586019303595239230&lt;/span&gt;&lt;/div&gt;
                    &lt;div class='new_order_creatime'&gt;
                        &lt;span&gt;退款时间:&lt;/span&gt;&lt;span&gt;2019-05-01  12:12:12&lt;/span&gt;
                        &lt;div class='oprater'&gt;&lt;span&gt;操作人：&lt;/span&gt;&lt;span&gt;苏晓燕&lt;/span&gt;&lt;/div&gt;
                    &lt;/div&gt;
                    &lt;div class='new_order_creatime'&gt;
                        &lt;span&gt;客服工单:&lt;/span&gt;&lt;span&gt;xxxxxxxxxxxxxxx&lt;/span&gt;
                    &lt;/div&gt;
                    &lt;div class='clear'&gt;&lt;/div&gt;
                  &lt;/div&gt;
              &lt;/div&gt;
           &lt;/van-card&gt;
           &lt;van-card&gt;
              &lt;div slot=&quot;title&quot;&gt;
                  &lt;div&gt;
                    &lt;div class='new_order_title'&gt;
                      &lt;div class='new_pay_price'&gt;&lt;span&gt;退款金额：&lt;/span&gt;&lt;span&gt;￥10.00&lt;/span&gt;&lt;div class='new_order_status'&gt;
                      &lt;/div&gt;
                      &lt;/div&gt;
                    &lt;/div&gt;
                    &lt;div class='new_order_mername'&gt;&lt;span&gt;退款单号: &lt;/span&gt;&lt;span&gt;cs00987934567&lt;/span&gt;&lt;/div&gt;
                    &lt;div class='new_order_container'&gt;&lt;span&gt;第三方退款单号: &lt;/span&gt;&lt;span&gt;ab999023904586019303595239230&lt;/span&gt;&lt;/div&gt;
                    &lt;div class='new_order_creatime'&gt;
                        &lt;span&gt;退款时间:&lt;/span&gt;&lt;span&gt;2019-05-01  12:12:12&lt;/span&gt;
                        &lt;div class='oprater'&gt;&lt;span&gt;操作人：&lt;/span&gt;&lt;span&gt;苏晓燕&lt;/span&gt;&lt;/div&gt;
                    &lt;/div&gt;
                    &lt;div class='new_order_creatime'&gt;
                        &lt;span&gt;客服工单:&lt;/span&gt;&lt;span&gt;xxxxxxxxxxxxxxx&lt;/span&gt;
                    &lt;/div&gt;
                    &lt;div class='clear'&gt;&lt;/div&gt;
                  &lt;/div&gt;
              &lt;/div&gt;
           &lt;/van-card&gt;
        &lt;/van-collapse-item&gt;
         &lt;van-collapse-item title=&quot;机柜信息&quot; name=&quot;3&quot; icon=&quot;shop-o&quot;&gt;
            &lt;van-card&gt;
              &lt;div slot=&quot;title&quot;&gt;
                  &lt;div&gt;
                    &lt;div class='new_order_title'&gt;
                      &lt;div class='new_pay_price'&gt;&lt;span&gt;机柜类型：&lt;/span&gt;&lt;span&gt;重力柜&lt;/span&gt;&lt;/div&gt;
                    &lt;/div&gt;
                    &lt;div class='new_order_mername'&gt;&lt;span&gt;商户名称: &lt;/span&gt;&lt;span&gt;动物园站知码开门xx&lt;/span&gt;&lt;/div&gt;
                    &lt;div class='new_order_container'&gt;&lt;span&gt;机柜位置: &lt;/span&gt;&lt;span&gt;北京市海淀区大柳树路175号&lt;/span&gt;&lt;/div&gt;
                    &lt;div class='new_order_creatime'&gt;
                        &lt;span&gt;投放地点:&lt;/span&gt;&lt;span&gt;富海国际港1703B室&lt;/span&gt;
                    &lt;/div&gt;
                    &lt;div class='clear'&gt;&lt;/div&gt;
                  &lt;/div&gt;
              &lt;/div&gt;
      &lt;/van-card&gt;
        &lt;/van-collapse-item&gt;
         &lt;van-collapse-item name=&quot;4&quot;&gt;
           &lt;div slot=&quot;title&quot;&gt;关联工单&lt;span class=&quot;detitle&quot;&gt;共4层&lt;/span&gt;&lt;/div&gt;
            &lt;van-card&gt;
              &lt;div slot=&quot;title&quot;&gt;
                  &lt;div&gt;
                    &lt;div class='new_order_title'&gt;
                      &lt;div class='new_worksheet_orderno'&gt;&lt;span&gt;订单编号：&lt;/span&gt;&lt;span&gt;BB06836365953495&lt;/span&gt;&lt;div class='new_order_status'&gt;
                        &lt;van-tag plain type=&quot;danger&quot; style=&quot;margin-right: 5px;&quot;&gt;
                          异常订单
                        &lt;/van-tag&gt;
                      &lt;/div&gt;
                      &lt;/div&gt;
                    &lt;/div&gt;
                    &lt;div class='new_order_creatime'&gt;
                              &lt;span&gt;问题类型:&lt;/span&gt;&lt;span&gt;金额错误&lt;/span&gt;
                              &lt;div class='oprater'&gt;&lt;span&gt;反馈来源：&lt;/span&gt;&lt;span&gt;在线客服&lt;/span&gt;&lt;/div&gt;
                    &lt;/div&gt;
                    &lt;div class='new_order_creatime'&gt;
                              &lt;span&gt;提交人:&lt;/span&gt;&lt;span&gt;苏晓燕&lt;/span&gt;
                              &lt;div class='oprater'&gt;&lt;span&gt;提交日期&lt;/span&gt;&lt;span&gt;2020-04-12&lt;/span&gt;&lt;/div&gt;
                    &lt;/div&gt;                 
                    &lt;div class='new_order_creatime'&gt;
                        &lt;span&gt;备注：&lt;/span&gt;&lt;span&gt;已经退款给商户了&lt;/span&gt;
                    &lt;/div&gt;
                    &lt;div class='clear'&gt;&lt;/div&gt;
                  &lt;/div&gt;
              &lt;/div&gt;
            &lt;/van-card&gt;
            &lt;van-card&gt;
              &lt;div slot=&quot;title&quot;&gt;
                  &lt;div&gt;
                    &lt;div class='new_order_title'&gt;
                      &lt;div class='new_worksheet_orderno'&gt;&lt;span&gt;订单编号：&lt;/span&gt;&lt;span&gt;BB06836365953495&lt;/span&gt;&lt;div class='new_order_status'&gt;
                        &lt;van-tag plain type=&quot;danger&quot; style=&quot;margin-right: 5px;&quot;&gt;
                          异常订单
                        &lt;/van-tag&gt;
                      &lt;/div&gt;
                      &lt;/div&gt;
                    &lt;/div&gt;
                    &lt;div class='new_order_creatime'&gt;
                              &lt;span&gt;问题类型:&lt;/span&gt;&lt;span&gt;金额错误&lt;/span&gt;
                              &lt;div class='oprater'&gt;&lt;span&gt;反馈来源：&lt;/span&gt;&lt;span&gt;在线客服&lt;/span&gt;&lt;/div&gt;
                    &lt;/div&gt;
                    &lt;div class='new_order_creatime'&gt;
                              &lt;span&gt;提交人:&lt;/span&gt;&lt;span&gt;苏晓燕&lt;/span&gt;
                              &lt;div class='oprater'&gt;&lt;span&gt;提交日期&lt;/span&gt;&lt;span&gt;2020-04-12&lt;/span&gt;&lt;/div&gt;
                    &lt;/div&gt;
                    &lt;div class='new_order_creatime'&gt;
                        &lt;span&gt;备注：&lt;/span&gt;&lt;span&gt;已经退款给商户了&lt;/span&gt;
                    &lt;/div&gt;
                    &lt;div class='clear'&gt;&lt;/div&gt;
                  &lt;/div&gt;
              &lt;/div&gt;
            &lt;/van-card&gt;
        &lt;/van-collapse-item&gt;
      &lt;/van-collapse&gt;
      &lt;div class='footer'&gt;
        &lt;div class='orderVedio' @click='cVideo()'&gt;&lt;span class='span1'&gt;订单视频&lt;/span&gt;&lt;/div&gt;
        &lt;div class='orderVedio1'&gt;&lt;span class='span1'&gt;创建工单&lt;/span&gt;&lt;/div&gt;
         &lt;!-- &lt;div class='orderVedio1' @click='cWorksheet()'&gt;&lt;span class='span1'&gt;创建工单&lt;/span&gt;&lt;/div&gt; --&gt;
      &lt;/div&gt;
      &lt;!-- 创建工单 --&gt;
      &lt;van-popup
        v-model=&quot;show_worksheet&quot;
        closeable
        close-icon=&quot;close&quot;
        position=&quot;bottom&quot;
        :style=&quot;{ height: '80%' }&quot;&gt;
        &lt;div style=&quot;padding:20px 0 60px 0&quot;&gt;
          &lt;van-divider :style=&quot;{ borderColor: 'gray', padding: '0 16px',fontSize:'16px',color:'#000' }&quot;&gt;
            创建工单
          &lt;/van-divider&gt;
          &lt;div class='orderno'&gt;订单编号：BB06829122482592&lt;/div&gt;
          &lt;van-collapse v-model=&quot;activeNames_type&quot;&gt;
           &lt;van-collapse-item title=&quot;请输入问题类型&quot; name=&quot;1&quot;&gt;
              &lt;!-- 单选 --&gt;
              &lt;van-radio-group v-model=&quot;radio&quot;&gt;
                &lt;van-cell-group&gt;
                  &lt;van-cell title=&quot;金额错误&quot; clickable @click=&quot;radio = '1'&quot;&gt;
                    &lt;van-radio slot=&quot;right-icon&quot; name=&quot;1&quot; /&gt;
                  &lt;/van-cell&gt;
                  &lt;van-cell title=&quot;识别错误&quot; clickable @click=&quot;radio = '2'&quot;&gt;
                    &lt;van-radio slot=&quot;right-icon&quot; name=&quot;2&quot; /&gt;
                  &lt;/van-cell&gt;
                   &lt;van-cell title=&quot;包装问题&quot; clickable @click=&quot;radio = '3'&quot;&gt;
                    &lt;van-radio slot=&quot;right-icon&quot; name=&quot;3&quot; /&gt;
                  &lt;/van-cell&gt;
                 &lt;van-cell title=&quot;过保质期&quot; clickable @click=&quot;radio = '4'&quot;&gt;
                    &lt;van-radio slot=&quot;right-icon&quot; name=&quot;4&quot; /&gt;
                  &lt;/van-cell&gt;
                &lt;van-cell title=&quot;其他&quot; clickable @click=&quot;radio = '5'&quot;&gt;
                    &lt;van-radio slot=&quot;right-icon&quot; name=&quot;5&quot; /&gt;
                  &lt;/van-cell&gt;
                &lt;/van-cell-group&gt;
              &lt;/van-radio-group&gt;
              &lt;!-- 单选 --&gt;
           &lt;/van-collapse-item&gt;
          &lt;/van-collapse&gt;
          &lt;van-field
            v-model=&quot;message&quot;
            rows=&quot;2&quot;
            autosize
            label=&quot;留言&quot;
            type=&quot;textarea&quot;
            maxlength=&quot;50&quot;
            placeholder=&quot;请输入留言&quot;
            show-word-limit
          /&gt;
          &lt;van-divider&gt;相关图片(0/{{fileList.length}})&lt;/van-divider&gt;
          &lt;div style=&quot;margin:0 0 0 5px&quot;&gt;
            &lt;van-uploader
            v-model=&quot;fileList&quot;
            multiple
            :max-count=&quot;4&quot;
            /&gt;
          &lt;/div&gt;
          &lt;div class=&quot;w_footer&quot;&gt;
            &lt;van-button type=&quot;default&quot;&gt;取消&lt;/van-button&gt;
            &lt;van-button type=&quot;primary&quot;&gt;确定&lt;/van-button&gt;
          &lt;/div&gt;
        &lt;/div&gt;
        &lt;/van-popup&gt;
         &lt;/el-scrollbar&gt;
        &lt;/div&gt;
       
   &lt;/div&gt;
&lt;/template&gt;
</code></pre>
<template>
      <div class="main">
      <div class="cardDiv">
        <el-scrollbar style="height:100%">
        <van-sticky>
          <van-card title="订单详情页">
            <div slot="title">
                <div>
                  <div class="new_order_title">
                    <div class="new_order_orderno"><span>订单编号：</span><span>BB06836365953495</span><div class="new_order_status">
                      <van-tag plain type="danger" style="margin-right: 5px;">
                        异常订单
                      </van-tag>
                    </div>
                    </div>
                  </div>
                  <div class="new_order_error">
                      <span>异常原因: </span><span>201-云端识别失败</span>
                  </div>
                  <div class="new_order_mername"><span>会员昵称: </span><span>苏晓燕</span></div>
                  <div class="new_order_container"><span>联系方式: </span><span>15801030115</span></div>
                  <div class="new_order_creatime">
                      <span>下单日期：</span><span>2019-05-01  12:12:12</span>
                  </div>
                  <div class="clear"></div>
                </div>
            </div>
          </van-card>
        </van-sticky>
      <van-collapse v-model="activeNames">
        <van-collapse-item name="1">
          <div slot="title">订单明细<span class="detitle">共4件商品合计:</span><span class="price">￥139</span></div>
           <van-card :thumb="imageURL">
        <div slot="title">
            <div>
              <div class="new_detail_goods"><span>商品：</span><span>百事可乐</span></div>
                <ul class="goodInfo">
                  <li><span>价格：</span><span>￥20.0</span></li>
                  <li><span>数量：</span><span>10件</span></li>
                  <li><span>原价：</span><span>￥20.0</span></li>
                </ul>
            </div>
        </div>
      </van-card>
       <van-card :thumb="imageURL">
        <div slot="title">
            <div>
              <div class="new_detail_goods"><span>商品：</span><span>百事可乐</span></div>
                <ul class="goodInfo">
                  <li><span>价格：</span><span>￥20.0</span></li>
                  <li><span>数量：</span><span>10件</span></li>
                  <li><span>原价：</span><span>￥20.0</span></li>
                </ul>
            </div>
        </div>
      </van-card>
        </van-collapse-item>
        <van-collapse-item title="支付信息" name="2" icon="shop-o">
           <van-card>
              <div slot="title">
                  <div>
                    <div class="new_order_title">
                      <div class="new_pay_price"><span>退款金额：</span><span>￥10.00</span><div class="new_order_status">
                      </div>
                      </div>
                    </div>
                    <div class="new_order_mername"><span>退款单号: </span><span>cs00987934567</span></div>
                    <div class="new_order_container"><span>第三方退款单号: </span><span>ab999023904586019303595239230</span></div>
                    <div class="new_order_creatime">
                        <span>退款时间:</span><span>2019-05-01  12:12:12</span>
                        <div class="oprater"><span>操作人：</span><span>苏晓燕</span></div>
                    </div>
                    <div class="new_order_creatime">
                        <span>客服工单:</span><span>xxxxxxxxxxxxxxx</span>
                    </div>
                    <div class="clear"></div>
                  </div>
              </div>
           </van-card>
           <van-card>
              <div slot="title">
                  <div>
                    <div class="new_order_title">
                      <div class="new_pay_price"><span>退款金额：</span><span>￥10.00</span><div class="new_order_status">
                      </div>
                      </div>
                    </div>
                    <div class="new_order_mername"><span>退款单号: </span><span>cs00987934567</span></div>
                    <div class="new_order_container"><span>第三方退款单号: </span><span>ab999023904586019303595239230</span></div>
                    <div class="new_order_creatime">
                        <span>退款时间:</span><span>2019-05-01  12:12:12</span>
                        <div class="oprater"><span>操作人：</span><span>苏晓燕</span></div>
                    </div>
                    <div class="new_order_creatime">
                        <span>客服工单:</span><span>xxxxxxxxxxxxxxx</span>
                    </div>
                    <div class="clear"></div>
                  </div>
              </div>
           </van-card>
        </van-collapse-item>
         <van-collapse-item title="机柜信息" name="3" icon="shop-o">
            <van-card>
              <div slot="title">
                  <div>
                    <div class="new_order_title">
                      <div class="new_pay_price"><span>机柜类型：</span><span>重力柜</span></div>
                    </div>
                    <div class="new_order_mername"><span>商户名称: </span><span>动物园站知码开门xx</span></div>
                    <div class="new_order_container"><span>机柜位置: </span><span>北京市海淀区大柳树路175号</span></div>
                    <div class="new_order_creatime">
                        <span>投放地点:</span><span>富海国际港1703B室</span>
                    </div>
                    <div class="clear"></div>
                  </div>
              </div>
      </van-card>
        </van-collapse-item>
         <van-collapse-item name="4">
           <div slot="title">关联工单<span class="detitle">共4层</span></div>
            <van-card>
              <div slot="title">
                  <div>
                    <div class="new_order_title">
                      <div class="new_worksheet_orderno"><span>订单编号：</span><span>BB06836365953495</span><div class="new_order_status">
                        <van-tag plain type="danger" style="margin-right: 5px;">
                          异常订单
                        </van-tag>
                      </div>
                      </div>
                    </div>
                    <div class="new_order_creatime">
                              <span>问题类型:</span><span>金额错误</span>
                              <div class="oprater"><span>反馈来源：</span><span>在线客服</span></div>
                    </div>
                    <div class="new_order_creatime">
                              <span>提交人:</span><span>苏晓燕</span>
                              <div class="oprater"><span>提交日期</span><span>2020-04-12</span></div>
                    </div>                 
                    <div class="new_order_creatime">
                        <span>备注：</span><span>已经退款给商户了</span>
                    </div>
                    <div class="clear"></div>
                  </div>
              </div>
            </van-card>
            <van-card>
              <div slot="title">
                  <div>
                    <div class="new_order_title">
                      <div class="new_worksheet_orderno"><span>订单编号：</span><span>BB06836365953495</span><div class="new_order_status">
                        <van-tag plain type="danger" style="margin-right: 5px;">
                          异常订单
                        </van-tag>
                      </div>
                      </div>
                    </div>
                    <div class="new_order_creatime">
                              <span>问题类型:</span><span>金额错误</span>
                              <div class="oprater"><span>反馈来源：</span><span>在线客服</span></div>
                    </div>
                    <div class="new_order_creatime">
                              <span>提交人:</span><span>苏晓燕</span>
                              <div class="oprater"><span>提交日期</span><span>2020-04-12</span></div>
                    </div>
                    <div class="new_order_creatime">
                        <span>备注：</span><span>已经退款给商户了</span>
                    </div>
                    <div class="clear"></div>
                  </div>
              </div>
            </van-card>
        </van-collapse-item>
      </van-collapse>
      <div class="footer">
        <div class="orderVedio" @click="cVideo()"><span class="span1">订单视频</span></div>
        <div class="orderVedio1"><span class="span1">创建工单</span></div>
         <!-- <div class='orderVedio1' @click='cWorksheet()'><span class='span1'>创建工单</span></div> -->
      </div>
      <!-- 创建工单 -->
      <van-popup v-model="show_worksheet" closeable close-icon="close" position="bottom" :style="{ height: '80%' }">
        <div style="padding:20px 0 60px 0">
          <van-divider :style="{ borderColor: 'gray', padding: '0 16px',fontSize:'16px',color:'#000' }">
            创建工单
          </van-divider>
          <div class="orderno">订单编号：BB06829122482592</div>
          <van-collapse v-model="activeNames_type">
           <van-collapse-item title="请输入问题类型" name="1">
              <!-- 单选 -->
              <van-radio-group v-model="radio">
                <van-cell-group>
                  <van-cell title="金额错误" clickable @click="radio = '1'">
                    <van-radio slot="right-icon" name="1">
                  </van-radio></van-cell>
                  <van-cell title="识别错误" clickable @click="radio = '2'">
                    <van-radio slot="right-icon" name="2">
                  </van-radio></van-cell>
                   <van-cell title="包装问题" clickable @click="radio = '3'">
                    <van-radio slot="right-icon" name="3">
                  </van-radio></van-cell>
                 <van-cell title="过保质期" clickable @click="radio = '4'">
                    <van-radio slot="right-icon" name="4">
                  </van-radio></van-cell>
                <van-cell title="其他" clickable @click="radio = '5'">
                    <van-radio slot="right-icon" name="5">
                  </van-radio></van-cell>
                </van-cell-group>
              </van-radio-group>
              <!-- 单选 -->
           </van-collapse-item>
          </van-collapse>
          <van-field v-model="message" rows="2" autosize label="留言" type="textarea" maxlength="50" placeholder="请输入留言" show-word-limit>
          <van-divider>相关图片(0/{{fileList.length}})</van-divider>
          <div style="margin:0 0 0 5px">
            <van-uploader v-model="fileList" multiple :max-count="4">
          </van-uploader></div>
          <div class="w_footer">
            <van-button type="default">取消</van-button>
            <van-button type="primary">确定</van-button>
          </div>
        </van-field></div>
        </van-popup>
         </el-scrollbar>
        </div>
   </div>
</template>


</section></template>
<style lang="less">
  .main{
    border:1px solid red;
    
    height:100%;
    
  
  
  }
.cardDiv{
    position: absolute;
    z-index: 1;
    box-sizing: border-box;
    width: 360px;
    min-width: 360px;
    background: #fafafa;
    border-radius: 12px;
    box-shadow: #a3a4a5 0 4px 12px;
    min-height:700px;
    right:30px;
    top:20px;
    
    
}
//订单详情
.price{
  font-size: 16px;
  font-weight: bold;
}
.detitle{
  font-size:12px;
  color:#ccc;
  margin-left:10px;
}
//商品详情
.new_order_orderno{
  font-size:14px;
}
.new_detail_goods{
  line-height: 22px;
}
.goodInfo li{
  display: inline-block;
  margin:0 2px;
}
.footer{
    width: 50px;
    position:absolute;
    bottom: 20%;
    right: 20px;
    height: 120px;
}
.footer .orderVedio{
  position:absolute;
  width:50px;
  height:50px;
  border-radius: 25px;
  background:sandybrown;
  opacity: .7;
  display: inline-block;
  text-align:center;
  line-height: 25px;
  color:#fff;
  font-size:12px;
  top:0;
  cursor: pointer;
}
.footer .orderVedio1{
  position:absolute;
  top: 70px;
  width:50px;
  height:50px;
  border-radius: 25px;
  background:sandybrown;
  opacity: .7;
  display: inline-block;
  text-align:center;
  line-height: 25px;
  color:#fff;
  font-size:12px;
  cursor: pointer;
}
.span1{
  position:absolute;
  width:30px;
  height:30px;
  top:50%;
  left:50%;
  margin-top:-15px;
  margin-left:-15px;
  display: inline-block;
  line-height:15px;
}

.w_footer{
  position:fixed;
  width:100%;
  bottom:10px;
  text-align: center;
}
.w_footer button{
  width:45%;
  margin:0 5px;

}

.orderno{
  font-size: 16px;
  font-weight: bold;
  padding:5px 0 10px 15px;
}

</style>
<script>
export default {
  i18n: {
    'zh-CN': {
      errorInfo: '错误提示',
      errorText: '请求失败，点击重新加载',
      pullRefresh: '下拉刷新',
      finishedText: '没有更多了',
    },
    'en-US': {
      errorInfo: 'Error Info',
      errorText: 'Request failed. Click to reload',
      pullRefresh: 'PullRefresh',
      finishedText: 'Finished',
    },
  },

  data() {
    return {
     fileList:[],
     message:'',
     activeNames_type:['0'],
     radio:'1',
     show_worksheet:false,
     activeNames: ['1'],
     imageURL: 'https://img.yzcdn.cn/vant/ipad.jpeg'
    };
  },

  methods: {
     cVideo(){
       //alert('查看视频')
       this.$toast.loading({
        message: '加载视频中...',
        forbidClick: true
      });
     },
     cWorksheet(){
       //alert('创建工单')
       this.show_worksheet = true;
     }
  }
};
</script>